import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { FileText, Eye, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDate } from "@/lib/format";

export default function CallDetailDialog({ call, onClose, photoSrc, onOpenPdf }) {
  const c = call || {};
  return (
    <Dialog open={!!call} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="call-detail-dialog">
        <DialogHeader>
          <DialogTitle className="pr-6">{c.outcome || "Bericht"}</DialogTitle>
          <DialogDescription className="flex items-center gap-2 flex-wrap">
            <Badge variant="outline" className="capitalize">{c.type}</Badge>
            {c.action_type && <Badge className="bg-indigo-100 text-indigo-700 hover:bg-indigo-100">{c.action_type}</Badge>}
            <span className="text-xs text-slate-400">{fmtDate(c.date)}</span>
          </DialogDescription>
        </DialogHeader>
        {c.recipients?.length > 0 && <p className="text-xs text-slate-500">Naar: {c.recipients.join(", ")}</p>}
        {c._letter && (
          <div className="flex gap-2">
            <Button size="sm" variant="outline" onClick={() => onOpenPdf(c._letter, false)} data-testid="call-detail-letter-open"><Eye className="h-3.5 w-3.5 mr-1.5" /> PDF openen</Button>
            <Button size="sm" variant="outline" onClick={() => onOpenPdf(c._letter, true)} data-testid="call-detail-letter-download"><Download className="h-3.5 w-3.5 mr-1.5" /> Download</Button>
          </div>
        )}
        {c.notes ? (
          <div className="text-sm text-slate-700 whitespace-pre-wrap break-words bg-slate-50 border rounded-lg p-4" data-testid="call-detail-body">{c.notes}</div>
        ) : (
          <p className="text-sm text-slate-400" data-testid="call-detail-body">Geen verdere berichttekst.</p>
        )}
        {c.agreements && <p className="text-sm text-slate-600"><b>Afspraken:</b> {c.agreements}</p>}
        {(c.attachments || []).length > 0 && (
          <div className="flex flex-wrap gap-2" data-testid="call-detail-attachments">
            {c.attachments.map((url, i) => (
              <a key={i} href={photoSrc(url)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border bg-white text-xs text-slate-700 hover:bg-slate-100" data-testid={`call-detail-attachment-${i}`}>
                <FileText className="h-3.5 w-3.5 shrink-0" /><span className="truncate max-w-[220px]">{decodeURIComponent(url.split("/").pop() || "") || `Bijlage ${i + 1}`}</span>
              </a>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
